<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos OT {{ idcotizacionvehiculo }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">


  			<div class="content bottom-0">
				
				<div data-height="215" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ fecha }}, {{ sucursal }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.marca }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.modelo }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.version }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.agno }}</h1>
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ OT.vin }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.placapatente }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-29"></div>
				</div>   

				<form onsubmit="event.preventDefault();" style="display:none" class="contactForm" id="Formsubmitvehiculo">
					<input id="kilometraje" name="field_IN_KILOMETRAJE_VEHICULO" v-model="OT.kilometraje">
					<input id="codvehiculo" v-model="OT.codvehiculo">
				</form>

                <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
                        <fieldset>
                            
							<span id="r_kilometraje" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Kilometraje requerido</span>
							<span id="i_kilometraje" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Kilometraje debe ser un número</span>
                            <div class="form-field form-name" style="text-align:left">
                                <label class="color-theme">Kilometraje:<span>(requerido)</span></label>
								<input id="kilometraje" name="field_IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO" 
								v-model="OT.kilometraje" 
								maxlength="6" 
								type="number" 
								@focus="onfocusnumericfield('kilometraje')" 
								@blur="onblurnumericfield('kilometraje')" 
								class="round-small">
                            </div>



							<input type="hidden" id="fechaentregaot" name="field_DT_FECHAENTREGAOT_COTIZACIONVEHICULO" v-model="OT.fechaentregaot">

							</br>

							<a href="#" @click="setFechaentrega" class="toggle-switch toggle-ios toggle-on" 
							data-toggle-height="30"
							data-toggle-width="50"
							data-toggle-content="toggle-content-3"
							data-toggle-checkbox="toggle-checkbox-3"
							data-bg-on="bg-green1-dark" 
							data-bg-off="bg-gray1-dark">
								<span class="color-theme regularbold font-14">Con Fecha/Hora de entrega definida</span>
								<strong></strong>
								<u></u>
							</a>

							<div class="toggle-content" id="toggle-content-3">

								<span id="r_fechaentrega" name="r_fechaentrega" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Fecha de entrega requerida</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Fecha entrega:<span>(requerida)</span></label>
									<input id="fechaentrega" name="fechaentrega" type="datetime-local"
									v-model="OT.fechaentrega" 
									class="round-small">
								</div>

								<!-- <span id="r_horaentrega" name="r_horaentrega" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Hora de entrega requerida</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Hora entrega:<span>(requerido)</span></label>
									<input id="horaentrega" type="time" name="horaentrega"
									v-model="OT.horaentrega" 
									class="round-small">
								</div> -->


                            </div>




							<br/>

							<div  class="content">
								<h4 class="bolder">Tipo de trabajo</h4>
								<br>
								<input type="hidden" id="datatipoot" name="field_IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO" v-model="OT.datatipoot">
								<span id="r_datatipotrabajo" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Tipo trabajo requerido</span>
								<input type="hidden" id="datatipotrabajo" name="field_IN_COD_TIPOTRABAJO" v-model="OT.datatipotrabajo">
								<div v-for="(tot, index) in tipotrabajo" class="content-boxed shadow-large one-half last-column bg-green1-light">
									<div class="content bottom-0">
										<h3 class="bolder">{{ tot.descripcion }}</h3>

										<span v-for="(l, index) in tot.lista">
											<span v-if="tot.listaselected">
												<button v-if="l.selected" v-bind:id="'mt_itemcbo_sel_'+l.index" @click="selecciontipotrabajo(tot.codtipoot,l.codtipotrabajo,l.index)" class="button button-s shadow-small button-circle bg-orange-dark">{{ l.descripcion }}</button>
												<button v-else v-bind:id="'mt_itemcbo_sel_'+l.index" @click="selecciontipotrabajo(tot.codtipoot,l.codtipotrabajo,l.index)" class="button button-s shadow-small button-circle bg-gray2-light">{{ l.descripcion }}</button>
											</span>
											<span v-else>
												<button v-bind:id="'mt_itemcbo_sel_'+l.index" @click="selecciontipotrabajo(tot.codtipoot,l.codtipotrabajo,l.index)" class="button button-s shadow-small button-circle bg-orange-light">{{ l.descripcion }}</button>
											</span>
										</span>
									</div>   

								</div>

							</div>

						
									


                        </fieldset>


						<div class="content-boxed">
								<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Siguiente</a>
						</div>

                    </form>			
                </div>
            </div>

 


    	</div>
		
    </div>


</template>

<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

export default {
	data() {
      return {
		params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
		paramsvehiculo:'',
		idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculo'),
		idagenda:localStorage.getItem('idagenda'),
		userimageurl:"background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")",  
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,

		tipotrabajo:[],

		OT:{
			  codvehiculo:0,
			  marca:"",
			  modelo:"",
			  version:"",
			  agno:"",
			  placapatente:"",
			  vin:"",

			  kilometraje:0,
			  datatipoot:"",
			  datatipotrabajo:"",
			  fechaentrega:"",
			  horaentrega:""
			  }
		}
	},

	created(){
		this.idcotizacionvehiculo=localStorage.getItem('idcotizacionvehiculo');
		this.idagenda=localStorage.getItem('idagenda');
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.sucursal=JSON.parse(localStorage.getItem('user')).sucursal  
		this.fecha=localStorage.getItem('fechaagenda')  

		db.getFx("ot.gettipotrabajo",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			console.log(result)
			this.tipotrabajo=result.data.data
			}});	
	},

	mounted() {      

		let strSql;

		strSql="UPDATE COT"
			+" SET IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO=IN_KILOMETRAJE_VEHICULO"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"		
			+" "
			+" UPDATE COT"
			+" SET IN_NCARTON_COTIZACIONVEHICULO=IN_COD_COTIZACIONVEHICULO"
			+" FROM T_VEH_COTIZACIONVEHICULO COT"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
		db.ExecuteQuery(strSql);

		strSql="SELECT ISNULL(IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO, 0) kilometraje,"
			+"V.IN_COD_VEHICULO codvehiculo,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data;
		}}); 
/*
		axios(db.Query(strSql)).then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.vehiculo=result.data.data;
		}});
		*/
		/*
		db.getDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
console.log(result.data.data)
			//field_DT_FECHAENTREGAOT_COTIZACIONVEHICULO
			this.OT=result.data.data
		}}); 
		*/
	},


	methods: {
		onfocusnumericfield(objid){validate.onfocusnumericfield(document.getElementById(objid))},
		onblurnumericfield(objid){validate.onblurnumericfield(document.getElementById(objid))},
		
		setFechaentrega()
			{
			if(document.getElementById("toggle-content-3").style.display!="none")
				{
					document.getElementById("r_fechaentrega").innerHTML="";
					document.getElementById("r_horaentrega").innerHTML="";
					document.getElementById("fechaentrega").value="";
					document.getElementById("horaentrega").value="";
				}
			else
				{
					document.getElementById("r_fechaentrega").innerHTML="Fecha de entrega requerida";
					document.getElementById("r_horaentrega").innerHTML="Fecha de entrega requerida";
				}

			},
			
		selecciontipotrabajo(codtipoot,codtipotrabajo,index)
			{
			document.getElementById("mt_itemcbo_sel_"+index).className="button button-s shadow-small button-circle bg-orange-dark"
			var i=1;

			while(document.getElementById("mt_itemcbo_sel_"+i)!=null)
				{
				if(i==index)
					{
					document.getElementById("mt_itemcbo_sel_"+i).className="button button-s shadow-small button-circle bg-orange-dark"
					document.getElementById("datatipoot").value=codtipoot
					document.getElementById("datatipotrabajo").value=codtipotrabajo
					}
				else
					{
					document.getElementById("mt_itemcbo_sel_"+i).className="button button-s shadow-small button-circle bg-gray2-light"
					}
				i=i+1;
				}

/*
			var intLen=document.getElementById("lista_tipoot").children.length;

			var i;
			for (i=0;i<intLen;i++)
				if(i!=index)
					document.getElementById("mt_itemcbo_"+codcaracteristica+"_sel_"+i).className="button button-s shadow-small button-circle bg-gray2-light"
			
			return false;
			*/
		},

		siguiente(){
			if(document.getElementById("fechaentrega").value=="" && document.getElementById("fechaentrega").value=="")
				document.getElementById("fechaentregaot").value=""
			else
				document.getElementById("fechaentregaot").value=document.getElementById("fechaentrega").value.replace("-","/") 
				//+ " " +document.getElementById("horaentrega").value

			var strErr=validate.check(Formsubmit)
			if (strErr==""){
				validate.Cleannumericfield(Formsubmit);

				this.paramsvehiculo='{"valkey":"'+this.OT.codvehiculo+'","tablename":"T_VEH_VEHICULO"}';
				db.sendDataForm(Formsubmitvehiculo,this.paramsvehiculo)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{

					db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						window.location="/Wizardot3characteristics"
					}});

				}});


			}

		}

	}
}

</script>
